import { makeObservable, observable, runInAction, reaction, toJS } from 'mobx';
import axios from "../utils/axios";
import reactionCombiner from "../utils/reactionCombiner";

class singleFileStore {
  data={};
  options={};
  cur_progress={};
  constructor(dataset) {
    makeObservable(this, {
      data: observable,
      options: observable,
      cur_progress: observable,
    });

    const comb=new reactionCombiner();

    if(dataset.onChange) {
      comb.addReaction(()=>{
        return this.data.tmp_file;
      },()=>{
        dataset.onChange(this.data);
      })
    }

    comb.addReaction(()=>{
      return this.data.fail;
    },(fail)=>{
      if(fail) {
        setTimeout(()=>{
          delete this.data.fail;
        },5000)
      }
    })

    if(dataset.data) {
      this.data = dataset.data;
    }

    this.options.inputName=dataset.inputName
    if(dataset.placeholder) {
      this.options.placeholder = dataset.placeholder
    }

    if(dataset.uploadOptions) {
      this.options.uploadOptions=JSON.parse(dataset.uploadOptions);
    } else {
      this.options.uploadOptions = {};
    }

    if(dataset.data) {
      const json=JSON.parse(dataset.data);
      if(json) {
        this.data=json;
      }
    }
  }
  setMarkFileWas() {
    const items=document.querySelectorAll('.editFormMain');
    if(items.length) {
      items[0].eva_gallery_changed = true;
    }
  }
  resetCurProgress() {
    this.cur_progress = {
      active:false,
      percent: 0,
      index: 0,
      cur_ob: null,
      total_size: 0,
      uploaded_size: 0,
      total_files: 0,
      uploaded_files: 0
    };
  }
  replaceCurFile(strOrFile) {
    runInAction(()=>{
      if(typeof strOrFile === "string") {
        this.data.uploading_url=strOrFile;
      } else {
        this.data.uploading_file=strOrFile;
      }
      this.startUpload();
    });
  }
  startUpload() {
    this.setMarkFileWas();
    runInAction(() => {
      this.resetCurProgress();
      this.cur_progress.active = true;
      this.cur_progress.uploaded_files = 0;
      if(this.data.uploading_file) {
        this.cur_progress.total_size += this.data.uploading_file.size;
      }
      this.data.progress = 0;
    });
    console.log("this.cur_progress", toJS(this.cur_progress));


    const cur = this.data;
    if (cur.uploading_file || cur.uploading_url) {
      const startTotal = toJS(this.cur_progress.uploaded_size);
      var formData = new FormData();
      if (cur.uploading_file) {
        formData.append("file", cur.uploading_file);
      }
      if (cur.uploading_url) {
        formData.append("url", cur.uploading_url);
      }
      formData.append("upload_options", JSON.stringify(toJS(this.options.uploadOptions)));

      axios.post('/sysapi/upload_tmp_file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (cur.uploading_file) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            runInAction(() => {
              cur.progress = percentCompleted;
              this.cur_progress.uploaded_size = startTotal + progressEvent.loaded;
              this.cur_progress.percent = Math.round(this.cur_progress.uploaded_size * 100 / this.cur_progress.total_size);
              this.cur_progress.index = 0;
              this.cur_progress.cur_ob = cur;
              console.log('this.cur_progress', toJS(this.cur_progress));
            });
          } else {
            runInAction(() => {
              cur.progress = 100;
              this.cur_progress.index = 0;
              this.cur_progress.cur_ob = cur;
              this.cur_progress.percent = 100;
              this.cur_progress.inf_uploading = true;
            });
          }
        }
      }).then((data) => {
        console.log("THEN");
        this.cur_progress.uploaded_files++;
        runInAction(() => {
          if (data.data.answer) {
            if (data.data.answer.success) {
              cur.success = true;
              cur.tmp_file = data.data.answer;
            }
          }
          if (!cur.success) {
            cur.fail = true;
          }
          cur.uploading = false;
          delete cur.uploading_file;
          delete cur.uploading_url;
        });
        this.resetCurProgress();
      }).catch((data) => {
        runInAction(() => {
          cur.uploading = false;
          delete cur.uploading_file;
          delete cur.uploading_url;
          cur.fail = true;
          this.resetCurProgress();
        });

      });
    }
  }
}

export default singleFileStore;